<template>
  <v-app>
    <gba-navbar />
    <v-card :height="windowSize.y" class="scroll" v-resize="onResize">

      <v-main>
        <transition name="fade" mode="out-in" >
          <router-view style="animation-duration: 0.4s" />
        </transition>
      </v-main>

      <v-dialog 
        v-model="updateExists" 
        transition="dialog-bottom-transition"
        persistent
        max-width="400"
      >
        <v-card flat>
          <v-card-text class="pa-4">
            <div class="text-center">
              <div class="text-h5 mb-8">A new GBA version is now available.</div>
              <v-btn 
                color="primary" 
                :large="$vuetify.breakpoint.xs ? false : true"
                @click="reloadApp">
                <v-icon class="mr-1">mdi-reload</v-icon> Reload
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>

    <v-overlay :value="isBusy">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <gba-notice 
      v-model="notice.on" 
      :text="notice.text" 
      :noticeType="notice.noticeType"
      :closeCallback="notice.closeCallback"
    />

  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
import Notice from "@/components/Notice";

export default {
  name: 'App',
  components: {
    'gba-navbar': Navbar,
    'gba-notice': Notice
  },
  data() {
    return {
      notice: {text: "", on: false, color: "info"},
      updateExists: false,
      windowSize: {x: 0,y: 0},
      isBusy: false
    }
  },
  async created() {
    window.addEventListener('gba-show-notice', this.addNotice);
    window.addEventListener('gba-set-scrollbar-theme', this.changeScrolling);
    window.addEventListener('gba-sw-updated', this.updateAvailable, { once: true });
    this.changeScrolling();

  },
  beforeDestroyed() {
    window.removeEventListener('gba-show-notice', this.addNotice);
    window.removeEventListener('gba-set-scrollbar-theme', this.changeScrolling);
  },
  computed: {
  },
  methods: {
    addNotice(e) {
      this.notice = {...e.detail};
    },
    getNoticeColor(noticeType)
    {
      switch (noticeType) {
        case 'warning':
          return 'secondary';
        case 'error':
          return 'error';
        case 'success':
          return 'success';
        default:
          return 'info';
      }
    },
    changeScrolling() {
      let scrollbarColor;
      let trackColor;
      let handleColor;
      if (this.$vuetify.theme.dark)
      {
        scrollbarColor = "#424242";
        trackColor = "#424242";
        handleColor = "#595959";
      } else {
        scrollbarColor= '#E0E0E0';
        trackColor='#E0E0E0';
        handleColor='#A0A0A0';
      }

      const bp = this.$vuetify.breakpoint.name;
      const style = `
        ::-webkit-scrollbar {
          /*display: none;*/
          width: ${bp==='xs'? 4 : 8}px;
          background:${scrollbarColor};
        }
        ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px ${trackColor}; 
        }
        ::-webkit-scrollbar-thumb {
          background: ${handleColor}; 
        }
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        input[type=number] {
          -moz-appearance:textfield;
        }`;
        
      const x = document.getElementById("scrollbarStyle");
      x.innerHTML = style;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    async reloadApp () {
      this.updateExists = false;
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    updateAvailable() {
      console.log("updateAvailable received in App.vue");
      this.updateExists = true;
    },
    uniqueId(prefix) {
      return `${prefix}_` +
        Math.random().toString(36) .substr(2, 9);
    },
  }
}
</script>
<style scoped>
.scroll {
  overflow-y: auto
}
</style>